export default __webpack_public_path__ + "static/media/whatsapp-icon.049c9513.svg";